module.exports = __webpack_public_path__ + "static/media/purplePoppedBalloon.889d8b18.svg";